import { getUserNoteStatusPercent } from 'core/utils/user';
import { useEffect, useMemo, useState } from 'react';

export default function useInputPointsQualitativeScale({ props, onChange, colorsPoints, evaluationScale }) {
  // Inicializar con el valor recibido
  const [value, setValue] = useState(props.value !== undefined && props.value !== null ? props.value : '');
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    // Actualizar el valor cuando cambia props.value
    setValue(props.value !== undefined && props.value !== null ? props.value : '');
  }, [props.value]);

  const statusColor = useMemo(() => {
    let status = 'default';
    if (colorsPoints) {
      status = getUserNoteStatusPercent(props.value, 10);
    }

    return status;
  }, [props.value, colorsPoints]);

  // Manejar el cambio en el select
  const onChangeOption = (e) => {
    const value = e.value;
    setValue(value);

    if (value === '') {
      onChange && onChange(null);
      setHasError(false);
      return;
    }

    // Pasar directamente el valor seleccionado
    onChange && onChange(value / 10);
    setHasError(false);
  };

  const onFocus = () => {
    if (value === '-') setValue('');
  };

  const onBlur = () => {
    if (value === '') setValue('-');
  };

  // Preparar las opciones para el select
  const options =
    evaluationScale?.ranges
      ?.map((item) => ({
        label: item.name,
        value: item.equivalence,
        originalItem: item, // Guardamos el objeto original para referencia
      }))
      ?.sort((a, b) => b.value - a.value) || []; // Ordenar por equivalence descendente (mayor primero)

  // Encontrar el valor seleccionado en las opciones ya formateadas
  const gradeValue = props.value !== undefined && props.value !== null ? props.value * 10 : null;
  const selectedOption =
    gradeValue !== null
      ? options.find((option) => {
          const originalItem = option.originalItem;
          // Si from es 100, permitimos que gradeValue sea igual a from
          if (originalItem.from === 100) {
            return gradeValue >= originalItem.to && gradeValue <= originalItem.from;
          } else {
            return gradeValue >= originalItem.to && gradeValue < originalItem.from;
          }
        })
      : null;

  return { value, hasError, onChangeOption, onFocus, onBlur, statusColor, options, selectedOption };
}
